module.exports = __webpack_public_path__ + "static/custom_alerts-7b128c05a154b0ba8e789feb38511654.png";